// extracted by mini-css-extract-plugin
export var footer = "_l7-0";
export var inherit = "_l7-1";
export var input = "_l7-2";
export var modalContent = "_l7-3";
export var quillEditor = "_l7-4";
export var subtitle = "_l7-5";